import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const router = new VueRouter({
    routes: [
        // {
        //     path: '/',
        //     name: 'index',
        //     component: require('./view/index.vue'),
        //     auth: true,
        //     meta: {
        //         keepAlive: false, // true 表示需要使用缓存
        //         isBack: false // 用于判断上一个页面是哪个
        //     }
        // },
        {
            path: '/:id',
            name: 'home',
            component: require('./view/home.vue'),
            auth: true
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }

})
export default router



// WEBPACK FOOTER //
// ./src/router.js